import { Person } from "@mui/icons-material";
import PropTypes from "prop-types";

import BaseField from "../../ui/BaseField";
import ValueWithFallback from "../../ui/ValueWithFallback";

import NameModel from "./NameModel";

export default function Name({ fieldName, prefix, name, flag, clock }) {
  return (
    <BaseField
      id="SB-Client-Name"
      testId="SB-Client-Name"
      fieldName={fieldName}
      flag={flag}
      clock={clock}
      contentClassName="flex flex-nowrap w-full"
    >
      <div className="h-[23px] flex-[1_1_auto]">
        <Person fontSize="inherit" />
        {ValueWithFallback(NameModel(prefix, name))}
      </div>
    </BaseField>
  );
}

Name.propTypes = {
  fieldName: PropTypes.string,
  prefix: PropTypes.any,
  name: PropTypes.string,
  flag: PropTypes.any,
  clock: PropTypes.any,
};
